import { parseTemplate } from 'url-template';
import mapProduct from '~/Api/Product/mapProduct';
import ApiClient, { ApiClientErrorResponse } from '~/ApiClient';

import Item from './Item';
import UpdateErrorResponse from './UpdateErrorResponse';

interface Result {
	productGroupItem: Item;
}

export default async function updateProductPackageSizeForSingleUnit(
	client: ApiClient,
	userId: string,
	groupId: string,
	productId: string,
	packageSizeForSingleUnit: string
): Promise<Result> {
	const url = parseTemplate(
		'users/{userId}/product-groups/{groupId}/products/{productId}/package-size-for-single-unit'
	);

	try {
		const request = await client.fetch(url.expand({ userId, groupId, productId }), {
			method: 'PUT',
			body: JSON.stringify({ packageSizeForSingleUnit }),
		});
		const { productGroupItem } = await request.json();
		return {
			productGroupItem: new Item(mapProduct(productGroupItem.product), productGroupItem.packageSizeForSingleUnit),
		};
	} catch (error) {
		throw error instanceof ApiClientErrorResponse
			? new UpdateErrorResponse(error.request, error.statusCode, error.errors)
			: error;
	}
}
